/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Please_Try_AgainInputs */

const en_mobile_please_try_again = /** @type {(inputs: Mobile_Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please try again.`)
};

const es_mobile_please_try_again = /** @type {(inputs: Mobile_Please_Try_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "Please try again." |
*
* @param {Mobile_Please_Try_AgainInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_please_try_again = /** @type {((inputs?: Mobile_Please_Try_AgainInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Please_Try_AgainInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_please_try_again(inputs)
	return en_mobile_please_try_again(inputs)
});